import { createSlice } from '@reduxjs/toolkit'
import { AxiosError } from '@src/helpers/httpClient'

import { GLOBAL_STATE, LETTER_INCOMING_LIST, LETTER_OUTGOING_LIST } from '../constants/actionTypes'
import * as actionCreators from './actions'
import { defaultState, initialState } from './initialState'

export const LETTERS = GLOBAL_STATE

export const { reducer: letterReducer } = createSlice({
  name: LETTERS,
  initialState,
  reducers: {},
  extraReducers(builder) {
    builder
      .addCase(actionCreators.letterIncomingList.pending, state => {
        state[LETTER_INCOMING_LIST].loading = true
      })
      .addCase(actionCreators.letterIncomingList.rejected, (state, action) => {
        state[LETTER_INCOMING_LIST].loading = false
        state[LETTER_INCOMING_LIST].error = action.payload as AxiosError
      })
      .addCase(actionCreators.letterIncomingList.fulfilled, (state, action) => {
        state[LETTER_INCOMING_LIST].loading = false
        state[LETTER_INCOMING_LIST].error = null
        state[LETTER_INCOMING_LIST].data = action.payload
      })

    builder
      .addCase(actionCreators.letterOutgoingList.pending, state => {
        state[LETTER_OUTGOING_LIST].loading = true
      })
      .addCase(actionCreators.letterOutgoingList.rejected, (state, action) => {
        state[LETTER_OUTGOING_LIST].loading = false
        state[LETTER_OUTGOING_LIST].error = action.payload as AxiosError
      })
      .addCase(actionCreators.letterOutgoingList.fulfilled, (state, action) => {
        state[LETTER_OUTGOING_LIST].loading = false
        state[LETTER_OUTGOING_LIST].error = null
        state[LETTER_OUTGOING_LIST].data = action.payload
      })

    builder.addCase(actionCreators.letterIncomingListClear, state => {
      state[LETTER_INCOMING_LIST] = defaultState()
    })

    builder.addCase(actionCreators.letterOutgoingListClear, state => {
      state[LETTER_OUTGOING_LIST] = defaultState()
    })
  },
})
